/**************
 Product Swiper
 **************/

// options for all swipers
const swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoHeight: true,
    zoom: {
        maxRatio: 2,
    },
    on: {
        slideChange: function () {
            // pause all videos
            document.querySelectorAll(".subVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
};

// check if there are multiple first
const multipleSwipers = document.querySelector("#subVisual.multiple");

// setup product swiper/s
if (multipleSwipers) {
// conditionally add multiple swipers with thumbnail functionality
    document.querySelectorAll('.subVisualSwiper').forEach((element, index) => {
        const productSwiper = new Swiper(element, swiperOptions);

        // update the thumbnail active class
        productSwiper.on('slideChange', function () {
            element.previousElementSibling.querySelector(".subVisualThumbsSlide.active")?.classList.remove("active");
            element.previousElementSibling.querySelectorAll(".subVisualThumbsSlide")[this.realIndex].classList.add("active");
        });

        // // change slide on thumbnail click
        element.previousElementSibling.querySelectorAll(".subVisualThumbsSlide").forEach(el => {
            el.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });
    });

} else {
    // setup single swiper
    const productSwiper = new Swiper(document.querySelector(".subVisualSwiper"), swiperOptions);

// change slide on thumbnail click
    document.querySelectorAll(".subVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update the thumbnail active class
    productSwiper.on('slideChange', function () {
        document.querySelector(".subVisualThumbsSlide.active")?.classList.remove("active");
        document.querySelectorAll(".subVisualThumbsSlide")[this.realIndex].classList.add("active");
    });
}

// play video on slide play click
document.querySelectorAll(".subVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".subVisualSwiperSlide").querySelector("video");

        if (!video) return;

        // remove play button if it hasn't already been removed
        this.querySelector(".subVisualSwiperSlidePlay")?.remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

/****************
 Product Variants
 ***************/

// select change on sticky ATC
document.querySelector('#subStickyBuyingSelect')?.addEventListener('change', function () {
    document.querySelector(`.subOptionItemValuesLabel input[value="${this.options[this.selectedIndex].textContent}"]`).click();
});

// update active variant on input changes
document.querySelectorAll("#sub input").forEach(function (element) {
    element.addEventListener("change", function () {
        inputChanges(element);
    });
})

// update active variant
function updateProduct(soldOut = false) {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.subOptionItem`).forEach(group => {
        options.push(group.querySelector(`input:checked`).value);
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#subATC").disabled = true;
        document.querySelector("#subATC").textContent = "Not Available";
        return;
    }

    // update variant title
    if (document.querySelector('.subVariantTitle')) document.querySelector('.subVariantTitle').textContent = activeVariant.title;

    // update variant description
    document.querySelector('.subUniqueDescription.active')?.classList.remove('active');
    document.querySelector(`.subUniqueDescription[data-name="${activeVariant.title}"]`)?.classList.add('active');

    // update variant slider images
    const variantTitle = activeVariant.title.split(' ').join('');
    if (multipleSwipers) {
        // hide existing active
        document.querySelector('.subVisualSwiper.active')?.classList.remove('active');
        document.querySelector('.subVisualThumbs.active')?.classList.remove('active');
        // reveal matching media
        document.querySelector(`.subVisualSwiper.${variantTitle}`).classList.add('active');
        document.querySelector(`.subVisualThumbs.${variantTitle}`).classList.add('active');
    }

    // update sticky ATC to same variant
    document.querySelector('#subStickyBuyingSelect').value = activeVariant.id;
    document.querySelector('#subStickyTitle.active')?.classList.remove('active');
    document.querySelector(`#subStickyTitle[data-id="${activeVariant.id}"]`).classList.add('active');

    // enable primary atc
    document.querySelector("#subATC").disabled = false;

    // check if the variant is in stock
    if (activeVariant.available && !soldOut) {
        document.querySelector("#subATC").classList.remove("soldOut");
        document.querySelector("#subATC").textContent = "TRY IT NOW";
        document.querySelector("#subStickyATC").disabled = false;
        document.querySelector("#subStickyATC").textContent = `TRY IT NOW ${price(activeVariant.price)}`;
    } else {
        document.querySelector("#subATC").classList.add("soldOut");
        document.querySelector("#subATC").textContent = "Sold Out - Notify Me When Available";
        document.querySelector("#subStickyATC").disabled = true;
        document.querySelector("#subStickyATC").textContent = "Sold Out";
    }

    // ships on
    document.querySelectorAll(`#subShipsOn span`).forEach(el => el.classList.remove('active'));
    document.querySelector(`#subShipsOn [data-id="${activeVariant.id}"]`)?.classList.add('active');

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// If on a page, update the active variant to mimic the product page
if (document.querySelector('#sub').classList.contains('page')) {
    const pageLink = String(window.location.href);
    console.log(pageLink)
    if (pageLink.includes("variant")) {
        const id = pageLink.split("variant=")[1];
        console.log(id)
        if (document.querySelector(`.subOptionItemValuesLabel[data-id="${id}"]`)) {
            document.querySelector(`.subOptionItemValuesLabel[data-id="${id}"] input`).checked = true;
            inputChanges(document.querySelector(`.subOptionItemValuesLabel[data-id="${id}"] input`))
            console.log("found change")
        }
    }
} else {
    updateProduct();
}

function inputChanges(element) {
    element.closest('.subOptionItem').querySelectorAll('label.active').forEach(el => {
        el.classList.remove("active");
        el.style.backgroundColor = "transparent";
    });

    // change label to active
    element.closest('label').classList.add("active");
    const color = element.closest('label').dataset.color;
    element.closest('label').style.backgroundColor = `${color}`;
    document.querySelector('#subGift').style.backgroundColor = `${color}`;
    // for max-holloway //
    if (color === "#b53c34") {
        document.querySelector('#subGift').style.color = "#fff";
    } else {
        document.querySelector('#subGift').style.color = "#000";
    }

    // check if marked sold out via metafield
    let soldOut = element.classList.contains('soldOut');
    updateProduct(soldOut);
}

/******************
 Product Sticky ATC
 ******************/

// listen for product area to scroll off page
window.addEventListener('scroll', () => {
    // compare product section and window
    let productBottom = document.querySelector('#sub')?.getBoundingClientRect().bottom;
    if (!productBottom) return;

    let windowTop = window.scrollY;

    if (windowTop - productBottom > 200) {
        // disable for launch
        document.querySelector('#subSticky').classList.add('active');
    } else {
        document.querySelector('#subSticky').classList.remove('active');
    }
})

document.querySelector('#subStickyATC')?.addEventListener('click', async function () {
    // add loading animation
    this.classList.add("loading");

    // get variant id
    let stickyId;
    if (document.querySelector('#subStickyBuyingSelect')) {
        stickyId = document.querySelector('#subStickyBuyingSelect').value;
    } else {
        stickyId = this.dataset.id;
    }

    // clear the cart
    await fetch("/cart/clear.js");

    // create form data
    let formData = {
        items: [
            {
                quantity: 1,
                id: activeVariant.id,
                selling_plan: subscriptionId
            },
            {
                // sampler pack
                quantity: 1,
                id: samplerVariantID
            }
        ]
    };

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

/***********
 Product ATC
 ***********/

document.querySelector("#subATC")?.addEventListener("click", async function () {
    // check for out of stock
    if (this.classList.contains("soldOut")) {
        // check email
        let {value: email} = await Swal.fire({
            title: `${product.title} / ${activeVariant.title}`,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        await sendKlaviyoBackInStockRequest(email, activeVariant.id);

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    const goToCart = this.classList.contains('goToCart');

    if (!goToCart) {
        // clear the cart
        await fetch("/cart/clear.js");
    }

    // create form data
    let formData = {
        items: [
            {
                quantity: 1,
                id: activeVariant.id,
                selling_plan: subscriptionId
            },
            {
                // sampler pack
                quantity: 1,
                id: samplerVariantID
            }
        ]
    };

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    if (goToCart) {
        // open cart
        await openCart();
    } else {
        // redirect to checkout
        window.location.href = '/checkout';
    }
});

/******
 Other
 *****/

// opens read the label modal
document.querySelector('.subLabelButton')?.addEventListener('click', () => {
    document.querySelector('#subLabelDialog').showModal();
    document.querySelector('body').classList.add('noScroll');
});

// closes read the label modal
function closeProductModal() {
    document.querySelector('#subLabelDialog').close();
    document.querySelector('body').classList.remove('noScroll');
}

document.querySelector('#subLabelDialogExit')?.addEventListener('click', () => {
    closeProductModal()
});

document.querySelector('#subLabelDialog')?.addEventListener('click', function (e) {
    if (e.target === this) {
        closeProductModal()
    }
});

document.querySelector('#subLabelDialog')?.addEventListener('close', () => {
    document.querySelector('body').classList.remove('noScroll');
});

// check if discount code is present
if (Cookies.get("discount_code")) {
    // set the discount code text
    document.querySelector("#couponfield").textContent = `${Cookies.get("discount_code").toUpperCase()} applied at checkout`;

    // show the discount code element
    document.querySelector("#couponfield").classList.add("active");
}

// scroll to reviews - allow time for page to load
setTimeout(() => {
    document.querySelector('#subReview').addEventListener('click', () => {
        const reviewSection = document.querySelector('.junip-product-review') || document.querySelector('.junip-review-section');
        if (reviewSection) {
            scrollUntilVisible(reviewSection);
        }
    })
}, 2000)

// update review count to have a comma
const reviewCount = document.querySelector("#subReviewCount").dataset.value;
document.querySelector("#subReviewCount").textContent = `(${parseInt(reviewCount).toLocaleString('en-US')})`;